export default __webpack_public_path__ + "static/0073-4bef917deec4ead7fc414ee77f8f2974.png";